import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/auth/login'
import { getStoredToken } from '@/auth/session'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/portal/LoginPage.vue'),
      meta: { public: true }
    },
    {
      path: '/',
      redirect: () => (isLoggedIn() ? '/portal' : '/login')
    },
    {
      path: '/home',
      redirect: '/'
    },
    {
      path: '/portal',
      name: 'portal',
      component: () => import('@/portal/vendor/index.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const t = getStoredToken()
  if (t && !sessionStorage.getItem('user_token')) {
    try { sessionStorage.setItem('user_token', t) } catch (e) {}
  }
  if (to.meta && to.meta.public) {
    if (to.name === 'login' && isLoggedIn() && to.query.force !== '1') {
      next({ path: '/portal' })
      return
    }
    next()
    return
  }
  if (!isLoggedIn()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
